import React from 'react';

function Footer() {
  return (
    <footer className="mt-5 py-3 border-top">
      <div className="container d-flex justify-content-end">
        <span className="text-muted small">
          Architected by{' '}
          <a href="https://sturgeon.tech" target="_blank" rel="noreferrer">
            Sturgeon Technologies
          </a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
